import { GeoObject } from '@data/geodata/legacy/GeoObject.js';
import FVector from '@data/geometry/FVector.js';
import { getColorScheme, getGlobalState } from '@gui/store/persistent/persistentStore.js';
import { getGrid } from 'store/LoadingStore';
import type { ColorScheme } from '@visualizer/types';

export type TargetPolygon = {
    id: number;
    vertices: FVector[];
    indices: number[];
    middlePoints: FVector[];
    points: FVector[];
};

export type Target = {
    polygons: TargetPolygon[];
    kind: number; // 1: Lake, 2: Forest, 3: Custom Polygon, 4: River
};

export class Targets extends GeoObject {
    targets: Target[] = [];

    constructor() {
        super();
        this.name = 'Targets';
    }

    isVisible() {
        return getGlobalState().context.showTargets;
    }

    override toggleVisibility() {
        super.toggleVisibility();
        getGrid().getActiveGeodata().dataObjectLegacy.Ground?.updateTerrainlineShader();
    }

    updateColors() {
        // placeholder
    }

    initTargetBorder() {}
}

export function getTargetColor(targetKind: number, colorScheme: ColorScheme = getColorScheme()) {
    if (!getGlobalState().context.showTargets) {
        return { fill: colorScheme.GROUND, stroke: colorScheme.GROUND_STROKE };
    }

    switch (targetKind) {
        case 1:
            return { fill: colorScheme.LAKE, stroke: colorScheme.LAKE_STROKE };
        case 2:
            return { fill: colorScheme.FOREST, stroke: colorScheme.FOREST_STROKE };
        case 3:
            return { fill: colorScheme.CUSTOM_POLYGON, stroke: colorScheme.CUSTOM_POLYGON_STROKE };
        case 4:
            return { fill: colorScheme.RIVER, stroke: colorScheme.RIVER_STROKE };
        default:
            throw new Error('Target not implemented');
    }
}
